import { useState } from 'react'
import { type UserRole } from '@/generated/graphql'
import { UsersContent } from '@/components/tables/UsersContent'

interface UsersTabProps {
  groupId?: string
  companyId?: string
  adminOnly?: boolean
  searchTerm?: string
  availableRoleFilters?: string[]
  allowedRoles?: string[]
  showUnassignUserFromGroup?: boolean
}

export function UsersTab({
  groupId,
  companyId,
  adminOnly = false,
  searchTerm,
  availableRoleFilters,
  allowedRoles,
  showUnassignUserFromGroup,
}: UsersTabProps = {}) {
  const [selectedRole, setSelectedRole] = useState<UserRole | 'all'>('all')

  return (
    <UsersContent
      searchTerm={searchTerm}
      selectedRole={selectedRole}
      onRoleChange={setSelectedRole}
      groupId={groupId}
      companyId={companyId}
      adminOnly={adminOnly}
      availableRoleFilters={availableRoleFilters}
      allowedRoles={allowedRoles as UserRole[]}
      showUnassignUserFromGroup={showUnassignUserFromGroup}
    />
  )
}
